import getBasePath from '../functions/api-resource';

const basePath = getBasePath('api', 'cep');

const cepActions = {
  obter: { method: 'GET', url: `${basePath}/{cep}` },
};

export default (resource) => resource(`${basePath}`, {}, cepActions);
